<template>
  <b-form-group
    label=""
    label-class="custom-form-input-label--internal"
    label-cols-sm="3"
    label-cols="12"
    content-cols="12"
    content-cols-sm="9"
    label-align-sm="right"
    label-align="left"
  >
    <b-alert
      show
      variant="warning"
      class="mb-0 py-2"
    >
      <font-awesome-icon
        :icon="['fas', 'exclamation-triangle']"
        class="mr-2"
      />
      <strong>Ringba Integration Required:</strong> To apply to CPA offers, you must first complete your Ringba integration.
      <router-link
        v-if="$store.getters['auth/hasPermission']('admin')"
        :to="{ name: 'RingbaIntegration' }"
        class="alert-link ml-2"
      >
        Complete Ringba Integration
      </router-link>
      <span v-else class="ml-2">Ask an account admin to configure the integration.</span>
    </b-alert>
  </b-form-group>
</template>

<script>
export default {
  name: 'CpaWebhookRequirementAlert'
}
</script>
